// extracted by mini-css-extract-plugin
export default {"tags":"tags_tags__d1Tgk","container":"tags_container__ZSMaX"};